<ppl-accordion [title]="'Denied Payroll'" [isOpen]="true">
    <div class="w-100">
        <ppl-timesheet-filter (searchEvent)="onSearch($event)" [filterFields]="filterFields"
            [includeProcessingStatus]="['D', 'CD']"></ppl-timesheet-filter>

        @if(!timesheets || timesheets.length == 0) {
        <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to find
            the
            records</div>
        }
    </div>
    @if(timesheets.length > 0) {
    <div class="table-style">
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false" [enableActions]="false"
            [data]="timesheets" [disableSelection]="true" [cols]="cols"
            [showExpandIcon]="true" [showLineItem]="true" [lineItemCols]="cols" [showLineItemActions]="false"
            [cellClassResolver]="cellClassResolver" (rowDetailEvent)="onRowExpanded($event)"
            (gridAction)="onAction($event)" (rowCellClicked)="onCellClicked($event)" [gridTitle]="false" [pagination]="true" [loadPage]="true" [customDataLoaded]="true" (onPageLoad)="onPageLoad($event)"
            [actionButtons]="actionButtons">
        </ppl-list-table>
    </div>
    }
</ppl-accordion>

<div class="filter-panel">
    <ng-template #deniedDialog let-cancel="cancel">
        <ppl-timesheet-staff-errorcode [errorcodeData]="deniedData" [disabled]="true"></ppl-timesheet-staff-errorcode>
    </ng-template>

    <ng-template #participantRejectedDialog let-cancel="cancel">
        <div class="ppl-mt20 p-4">
            @if (participantRemarks) {
            <table class="table">
                <thead>
                    <tr>
                        <th style="background-color: #a8e4e14d;">Reason</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><span>{{ participantRemarks }}</span></td>
                    </tr>
                </tbody>
            </table>
            } @else {
            <div class="alert alert-warning">No Records Found.</div>
            }
        </div>
    </ng-template>
</div>
